import { Button } from 'components/button/Button';
import LoadingSpinner from 'components/LoadingSpinner';
import Modal, { ModalButtons } from 'components/Modal';

interface CopyToWorkspaceModalProps {
    isCopying: boolean;
    onCopy: () => void;
    close: () => void;
}

export const CopyToWorkspaceModal = ({ close, isCopying, onCopy }: CopyToWorkspaceModalProps) => {
    return (
        <Modal title='Copy to workspace' close={close} fullWidth maxWidth='max-w-3xl'>
            <div className='px-8 py-4'>
                <p>
                    Copying this dashboard to your workspace allows you to make changes and share it with other users.
                </p>
            </div>
            <ModalButtons>
                <Button type='button' disabled={isCopying} variant='tertiary' onClick={() => close()}>
                    Cancel
                </Button>
                <Button type='submit' data-testid='copy-to-workspace' onClick={onCopy} disabled={isCopying}>
                    {isCopying && <LoadingSpinner size={18} className='mr-2' />}
                    Copy
                </Button>
            </ModalButtons>
        </Modal>
    );
};
